export default {
  productName: 'Bag Ring',
  pathId: 'fightcamp-bag-ring',
  description: 'The Bag Ring keeps the FightCamp Boxing Bag directly in front of you. No more sliding or adjusting the free-standing bag between rounds. Designed for stability, protection, and ease of use during intense workouts.',
  shortDescription: 'Keep your FightCamp Bag stable and your floors protected with this easy-to-install ring.',
  testShopifyId: 'gid://shopify/Product/7091668811865',
  prodShopifyId: 'gid://shopify/Product/7667402899692',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/1200x825/556f35d85b/dscf0299.jpg',
    alt: 'FightCamp Bag Ring',
  },
  lifestyleImage: {
    src: 'https://a.storyblok.com/f/152150/1648x1648/ea6b30a5cc/fc-freestanding-bag-ring.jpg',
    alt: 'FightCamp Bag Ring on floor with bag',
  },
  includesModalCopy: {},
  assets: [{
    src: 'https://a.storyblok.com/f/152150/1200x825/556f35d85b/dscf0299.jpg',
    alt: 'FightCamp Bag Ring',
  },
  {
    src: 'https://a.storyblok.com/f/152150/1200x825/ef7d808a24/dscf0305.jpg',
    alt: 'FightCamp Bag Ring with bag base',
  },
  {
    src: 'https://a.storyblok.com/f/152150/1200x825/46a8d35e3b/fc_product_shoot_2025-105.jpg',
    alt: 'FightCamp Bag Ring with bag',
  },
  ],
  features: [
    {
      title: 'Features',
      copy: [
        'Prevents the FightCamp Bag from sliding or shifting during training',
        'Protects flooring from scuffs and damage',
        'Designed for use with FightCamp\'s free-standing bag system',
      ],
    },
    {
      title: 'Size & Fit',
      copy: [
        '24” diameter circular mat',
        'Fits securely around the base of the FightCamp Bag',
      ],
    },
    {
      title: 'Materials & Care',
      copy: [
        'Heavy-duty rubber mat and high-quality plastic bumpers',
        'Wipe clean with a damp cloth',
        'Store indoors when not in use to extend product life',
      ],
    },
  ],
};
